<template>
  <div class="contaier">
    <page-header></page-header>
    <div class="top-banner">
      <!-- <el-carousel trigger="click" :height="paramH">
        <el-carousel-item v-for="item in modelList" :key="item.id">
          <img :src="item.imgKV" loading="lazy" alt="" />
        </el-carousel-item>
      </el-carousel> -->
      <!-- 主图轮播 -->
      <!-- img-box_error -->
      <div class="swiper-wrap">
        <div class="swiper-box img-box_error">
          <swiper
            class="gallery-top"
            ref="swiperMain"
            :options="mainOptions"
            @slide-change="onMainSlideChange">
            <swiper-slide v-for="(item, i) in homeModelList" :key="i">
              <div class="swiper-slide">
                <div class="btn-box">
                  <div class="car-name_box">
                    <div class="car-hq">HONGQI</div>
                    <div class="car-name" v-if="item.modelName">
                      {{ item.modelName }}
                    </div>
                  </div>
                  <div
                    class="btn"
                    v-if="item.modelName"
                    @click="goNewPage2('/carDetails', item.id)">
                    {{ $t('public.learnMore') }}
                  </div>
                  <template v-else>
                    <div class="title6">{{ $t('home.title6') }}</div>
                    <div class="title6">{{ $t('home.title6_2') }}</div>
                  </template>
                </div>

                <div class="img-box">
                  <!-- <img v-lazy="item.imgKV" class="main-img" /> -->
                  <!-- <img :src="item.imgKV" class="main-img" /> -->
                  <!-- <img :src="item.imgKV_mobile" class="main-img" /> -->
                  <picture>
                    <source
                      alt="响应式图片1"
                      media="(max-width: 668px)"
                      :srcset="item.imgKV_mobile" />
                    <img :src="item.imgKV" alt="响应式图片" />
                  </picture>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <!-- 自定义箭头 -->
          <!-- <div class="custom-arrow prev" @click="prevSlide">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
          </div> -->
          <!-- <div class="custom-arrow next" @click="nextSlide">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
            </svg>
          </div> -->

          <div class="show-box">
            <div
              class="show"
              :key="itme"
              :class="{ 'show-ac': mainI === index }"
              v-for="(itme, index) in homeModelList.length"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="explorers-hongqi">
      <div class="hq-title1">{{ $t('public.exploreH') }}</div>
      <div class="t-car">
        <div
          class="t-car_item"
          @click="clickCar(index)"
          v-for="(item, index) in modelList"
          :key="item.id">
          <div class="img-box img-box_error">
            <img class="c-img" alt="hongqi" :src="item.side_90" />
          </div>
          <div class="car-name" :class="{ 'car-name_ac': carIndex === index }">
            {{ item.modelName }}
          </div>
        </div>
        <!-- <div class="t-car_item" @click="clickCar(1)">
          <img
            class="c-img"
            alt="E-QM5"
            src="./../assets/img/cars/EV/E-QM5/E-qm5.png" />
          <div class="car-name" :class="{ 'car-name_ac': carIndex === 1 }">
            E-QM5
          </div>
        </div> -->
      </div>
      <div class="explorers-bg">
        <div class="car-box_out">
          <div :key="item.id" v-for="(item, index) in modelList">
            <div
              :key="item.id"
              class="title-box"
              :class="{ 'title-box_curr': carIndex === index }">
              <div class="hq-t_b">{{ item.modelName }}</div>
              <div class="btn" @click="goNewPage2('/carDetails', item.id)">
                {{ $t('public.explore') }}
              </div>
            </div>
          </div>
          <div
            class="car-box"
            :key="`car${item.id}`"
            v-for="(item, index) in modelList"
            :class="{ 'car-box_curr img-box_error': carIndex === index }">
            <div
              :key="item2.id"
              class="car-img_box"
              v-for="(item2, index2) in item.exterior">
              <img
                class="car-img"
                :class="{ 'car-img_ac': carIndex2 === index2 }"
                :src="item2.front_45_side" />
              <!-- <el-image
                fit="cover"
                class="car-img"
                :src="item2.front_45_side"
                :class="{ 'car-img_ac': carIndex2 === index2 }"
                :preview-src-list="item2.front_45_sideArr">
              </el-image> -->
            </div>
            <!-- v-if="carIndex2 === index2" /> -->
          </div>
        </div>
        <!-- :class="{ 'car-img_ac': carIndex2 === index2 }"  -->
        <template v-for="(item, index) in modelList">
          <div :key="item.id" class="car-select max-box">
            <template v-if="carIndex === index">
              <div
                class="car car1"
                :class="{ 'car-ac': carIndex2 === index2 }"
                :key="item2.id"
                v-for="(item2, index2) in item.exterior"
                @click="clickColorCar2(index2)">
                <img class="car-color" :src="item2.front_color" />
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
    <!-- 以下先不做 -->
    <div class="about-hq">
      <div class="about-box">
        <div class="hq-title1">{{ $t('public.about') }}</div>
        <div class="box img-box_error">
          <div class="about-item">
            <img class="car-img" src="@/assets/img/homeAbout/1.jpg" />
            <div class="mask"></div>
            <div class="text">{{ $t('public.history') }}</div>
            <div class="btn" @click="goNewPage('/about')">
              {{ $t('public.learnMore') }}
            </div>
          </div>
          <!-- <div class="about-item" v-for="item in aboutList" :key="item.id">
            <img class="car-img" :src="item.img" />
            <div class="mask"></div>
            <div class="text">{{ item.text }}</div>
            <div class="btn">learn more</div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="events-hq">
      <div class="events-box">
        <div class="hq-title1">{{ $t('public.newsTitle') }}</div>
        <div class="box">
          <div
            :key="item.id"
            class="about-item"
            v-for="item in newsList"
            @click="goNewPage2('/news', item.id)">
            <!-- <img class="car-img" :src="item.img" /> -->
            <!-- :preview-src-list="item.imgArr" -->
            <el-image fit="cover" :src="item.img" class="car-img"> </el-image>
            <div class="text">{{ langShow(item.title) }}</div>
            <div class="b-box">
              <div class="date">{{ item.createTime }}</div>
              <div class="btn">
                {{ $t('public.learnMore') }}
              </div>
            </div>
          </div>
        </div>
        <div class="more-news" @click="clickToMore">
          {{ $t('home.moreNews') }}
        </div>
      </div>
    </div>
    <footer-page></footer-page>
  </div>
</template>

<script>
import { throttle } from 'lodash'
import { activityTime } from '@/utils/utils'
import { langMixins } from '@/mixins/langMixins'
import { modelListApi, newsListApi } from '@/Api/requestApi'
import PageHeader from '@/components/PageHeader.vue'
import FooterPage from '@/components/FooterPage.vue'
import {
  imgBase,
  aboutList,
  eventsList,
  // homeSwiper,
  homeMobileSwiper,
} from '@/assets/js/static'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'HomeView',
  mixins: [langMixins],
  components: {
    PageHeader,
    FooterPage,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      aboutList,
      eventsList,
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      // homeSwiper
      speak: '中文',
      carIndex: 0,
      carIndex2: 0,
      paramH: '810px',
      // windowWidth:1680
      modelList: [],
      homeModelList: [],
      mainSwiper: null,
      scrollHandler: null,
      mainOptions: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'slide',
        speed: 300,
        uniqueNavElements: false,
      },
      mainI: 0,
      newsList: [],
    }
  },
  mounted() {
    this.mainSwiper = this.$refs.swiperMain?.$swiper
    this.modelListFn()
    this.getNewsListFn()
    this.$nextTick(() => {
      this.scrollHandler = throttle(this.handleResize, 200)
      window.addEventListener('resize', this.scrollHandler)
      this.handleResize()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      // console.log('22222 :>> ', 22222)
      // 获取 Swiper 实例
      this.langFn()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scrollHandler)
  },
  methods: {
    handleResize() {
      let ww_ = window.innerWidth
      // console.log('ww_ :>> ', ww_);
      if (ww_ < 668) {
        // this.paramH = '760px'
        // this.paramH = '460px'
      } else if (ww_ < 768) {
        // this.paramH = '760px'
        // this.paramH = '500px'
      } else if (ww_ < 992) {
        // this.paramH = '660px'
      } else {
        // this.paramH = '810px'
      }
      // this.currentIndex = 0
      // this.windowWidth = ww_
    },
    async modelListFn() {
      const {
        data: { code, data },
      } = await modelListApi({ state: 1 })
      if (code == 200) {
        let list_ = []
        let homeList_ = [
          {
            id: 1000,
            // side_90,
            modelName: '',
            // exterior: exterior_,
            // imgKV: homeSwiper,
            imgKV: 'https://img.kamlung.net/hk/home_hq_kv.jpg',
            imgKV_mobile: homeMobileSwiper,
          },
        ]
        console.log('data :>> ', data)
        for (let i = 0; i < data.length; i++) {
          let exterior_ = []
          const { id, imgKV, imgKV_mobile, modelName, exterior } = data[i]
          let side_90 = ''
          for (let j = 0; j < exterior.length; j++) {
            const { front_45_side, front_90_side, front_color } = exterior[j]
            if (j === 0) {
              side_90 = `${imgBase}${front_90_side}?iopcmd=thumbnail&type=4&width=400&quality=60`
            }
            exterior_.push({
              id: j + 1,
              front_45_side: `${imgBase}${front_45_side}?iopcmd=thumbnail&type=4&width=700&quality=60`,
              front_45_sideArr: [`${imgBase}${front_45_side}`],
              front_90_side: `${imgBase}${front_90_side}`,
              front_color: `${imgBase}${front_color}`,
            })
          }
          list_.push({
            id,
            side_90,
            modelName,
            exterior: exterior_,
            imgKV: `${imgBase}${imgKV}`,
            imgKV_mobile: `${imgBase}${imgKV_mobile}`,
          })

          homeList_.push({
            id,
            // side_90,
            modelName,
            // exterior: exterior_,
            imgKV: `${imgBase}${imgKV}`,
            imgKV_mobile: `${imgBase}${imgKV_mobile}`,
          })
        }
        // console.log('list_ :>> 222', list_)
        this.modelList = list_
        this.homeModelList = homeList_
      }
    },
    clickCar(i) {
      // this.carIndex2 = -1;
      // this.$nextTick(() => {
      this.carIndex2 = 0
      this.carIndex = i
      // });
    },
    clickColorCar2(i) {
      console.log('00000000 :>> ', 444)
      // this.carIndex = 0;
      this.carIndex2 = i
    },
    goNewPage(p) {
      this.$router.push({ path: p, query: { lang: this.$i18n.locale } })
    },
    goNewPage2(p = '/carDetails', id) {
      // console.log('i :>>666 ', i_)
      if (p === '/carDetails') {
        let i_ = this.carIndex2
        this.$router
          .push({
            path: p,
            query: { id, lang: this.$i18n.locale, cI: i_ },
          })
          .catch(() => {})
      } else {
        this.$router
          .push({
            path: p,
            query: { id, lang: this.$i18n.locale },
          })
          .catch(() => {})
      }
      // return
    },
    // --------------------------------
    // 上一张
    prevSlide() {
      // console.log('点击上一张', this.mainSwiper)
      if (this.mainSwiper) {
        this.mainSwiper.slidePrev()
        this.currentIndex = this.mainSwiper.activeIndex
        // console.log('当前索引:', this.mainSwiper.activeIndex)
      }
    },
    // 下一张
    nextSlide() {
      // console.log('点击下一张', this.mainSwiper)
      if (this.mainSwiper) {
        this.mainSwiper.slideNext()
        this.currentIndex = this.mainSwiper.activeIndex
        // console.log('当前索引:', this.mainSwiper.activeIndex)
      }
    },
    // 主图切换事件
    onMainSlideChange() {
      // console.log(
      //   'this.mainSwiper.activeIndex :>> ',
      //   this.mainSwiper.activeIndex
      // )
      this.mainI = this.mainSwiper?.activeIndex || 0
      // if (this.mainSwiper && this.thumbSwiper) {
      //   const newIndex = this.mainSwiper.activeIndex
      //   this.currentIndex = newIndex
      //   if (this.thumbSwiper.activeIndex !== newIndex) {
      //     this.thumbSwiper.slideTo(newIndex, 300)
      //   }
      // }
    },
    langShow(p) {
      if (!p) {
        return ''
      }
      return p[this.$i18n.locale]
    },
    async getNewsListFn() {
      const {
        data: { code, data },
        // } = await newsListApi({ state: '' })
      } = await newsListApi({ state: 1 })
      if (code == 200) {
        let newsList_ = []
        for (let i = 0; i < data.length; i++) {
          let {
            id,
            title,
            titleEn,
            content,
            contentEn,
            titleImage,
            createTime,
          } = data[i]
          newsList_.push({
            id,
            title: { zh: title, en: titleEn },
            // imgArr: [`${imgBase}${titleImage}`],
            createTime: activityTime(createTime),
            content: { zh: content, en: contentEn },
            img: `${imgBase}${titleImage}?iopcmd=thumbnail&type=4&width=600&quality=60`,
          })
        }
        this.newsList = newsList_
        console.log('newsList_ :>> ', newsList_)
      }
    },
    clickToMore() {
      this.$router
        .push({ path: '/newsList', query: { lang: this.$i18n.locale } })
        .catch(() => {})
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
// @import 'element-ui/lib/theme-chalk/display.css';

.el-carousel__item {
  margin: 0;
}

.img {
  object-fit: cover;
}
.contaier {
  .top-banner {
    width: 100%;
    margin-top: 108px;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }
  // ------------------------ swiper**start ------------------------
  .swiper-wrap {
    width: 100%;
    background-color: #fafafa;
    .swiper-box {
      position: relative;
      aspect-ratio: 16 / 6;

      .show-box {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 666;
        .show {
          width: 20px;
          height: 5px;
          margin: 0 5px;
          background-color: rgba(255, 255, 255, 0.6);
        }
        .show-ac {
          background-color: #fff;
        }
      }
    }
    /* 主图样式 */
    .gallery-top {
      overflow: hidden;

      .swiper-slide {
        position: relative;
        max-height: 860px;
        .btn-box {
          // width: 400px;
          position: absolute;
          top: 15%;
          left: 15%;
          // top: 60px;
          // left: 80px;
          .car-name_box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #fff;
            .car-hq {
              padding-right: 20px;
              font-size: 60px;
            }
            .car-name {
              font-weight: 300;
              font-size: 30px;
            }
          }
          .btn {
            width: 140px;
            margin-top: 20px;
            line-height: 40px;
            font-size: 14px;
            text-align: center;
            font-weight: 600;
            color: #fff;
            background-color: #2f3944;
            cursor: pointer;
          }
          .title6 {
            font-size: 32px;
            color: #fff;
          }
        }
      }

      .img-box {
        // background-color: #fafafa;
        // background-color: red;
        .main-img {
          width: 100%;
          aspect-ratio: 16 / 8;
          object-fit: cover;
          display: block;
        }
      }
    }

    /* 自定义箭头按钮 */
    // .custom-arrow {
    //   position: absolute;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   width: 44px;
    //   height: 44px;
    //   background: rgba(0, 0, 0, 0.6);
    //   backdrop-filter: blur(4px);
    //   border-radius: 50%;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   cursor: pointer;
    //   z-index: 10;
    //   transition: all 0.3s ease;
    //   opacity: 0.8;
    // }

    // .custom-arrow.prev {
    //   left: 20px;
    // }

    // .custom-arrow.next {
    //   right: 20px;
    // }
  }

  // ------------------------ 车**start ------------------------
  .explorers-hongqi {
    padding-top: 60px;
    padding-bottom: 60px;
    .hq-title1 {
      padding-bottom: 20px;
    }
    .t-car {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 40px;
      cursor: pointer;
      .t-car_item {
        flex: 1;
        max-width: 300px;
        margin: 0 40px;
        text-align: center;
        .img-box {
          aspect-ratio: 16 / 8;
        }
        .car-name {
          width: 100px;
          margin: 0 auto;
          // padding-bottom: 1.4vw;
          padding-bottom: 10px;
          border-bottom: solid 2px #fff;
        }
        .car-name_ac {
          font-weight: 600;
          border-bottom: solid 2px #222;
        }
      }
    }
    .explorers-bg {
      height: 450px;
      background-image: url('@/assets/img/cartype_bg.jpg');
      background-position: bottom center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: relative;
      .car-box_out {
        position: relative;
        height: 100%;
        overflow: hidden;
        .car-box {
          width: 100%;
          max-width: 650px;
          aspect-ratio: 13 / 5.2;
          position: absolute;
          top: 50%;
          right: -100%;
          transform: translate(50%, -50%);
          transition: right 0.6s;
          opacity: 0;
        }
        .car-box_curr {
          // top: 50%;
          right: 40%;
          opacity: 1;
          .car-img_box {
            position: relative;
            .car-img {
              width: 100%;
              aspect-ratio: 16 / 6.8;
              object-fit: cover;
              position: absolute;
              top: 0;
              left: 0;
              opacity: 0;
              transition: opacity 0.6s ease;
              // background-color: #fafafa;
            }
            .car-img_ac {
              opacity: 1;
            }
          }
        }
      }
      .car-select {
        position: absolute;
        bottom: 20px;
        // left: 200px;
        left: 20%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .car {
          width: 60px;
          height: 60px;
          margin-right: 10px;
          border-radius: 50%;
          overflow: hidden;
          border: solid 3px #fff;
          cursor: pointer;
          .car-color {
            width: 100%;
            height: 100%;
          }
        }
        .car:hover {
          border: solid 3px #333;
        }
        .car-ac {
          border: solid 3px #333;
        }
      }
      .title-box {
        width: 300px;
        position: absolute;
        top: 10%;
        left: -80%;
        transform: translate(50%, 0%);
        z-index: 99;

        .hq-t_b {
          font-size: 46px;
          margin-bottom: 10px;
        }
        .btn {
          width: 200px;
          margin: 0 auto;
          font-size: 16px;
          line-height: 60px;
          font-family: 'HongqiFontBold';
          cursor: pointer;
          text-align: center;
          color: #fff;
          background-color: #333;
        }
      }
      .title-box_curr {
        top: 10%;
        left: 20%;
        transform: translate(0%, 0%);
        transition: all 0.6s;
      }
    }
  }
  // ------------------------ 关于红旗**start ------------------------
  .about-hq {
    padding: 60px 0;
    background-color: #f3f3f3;
    .about-box {
      max-width: 1770px;
      margin: 0 auto;
      .hq-title1 {
        padding-bottom: 30px;
      }
    }
    .box {
      // display: flex;
      // justify-content: space-between;
      // flex-wrap: wrap;
      max-width: 1200px;
      aspect-ratio: 16 / 8;
      object-fit: cover;
      margin: 0 auto;

      .about-item {
        overflow: hidden;
        position: relative;
        // transition: all 0.6s;

        .car-img {
          width: 100%;
          // aspect-ratio: 16 / 8;
          transition: all 0.6s;
          // transform: scale3d(1, 1, 1);
        }
        // .car-img_ac {
        //   opacity: 1;
        //   width: 100%;
        //   // transition: all 0.6s;
        //   // transform: scale3d(1, 1, 1);
        // }
        .car-img:hover {
          //   transition: all 0.6s;
          // transform: scale3d(1.1, 1.1, 1.1);
        }

        .mask {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
          background-color: rgba(000, 000, 000, 0.4);
        }

        .text {
          font-size: 38px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-weight: 600;
          z-index: 99;
          overflow: hidden;
          text-align: center;
          color: #fafafa;
        }
        .btn {
          width: 12vw;
          // max-width: 30%;
          // height: 3vw;
          line-height: 3vw;
          font-size: 14px;
          position: absolute;
          bottom: 80px;
          left: 50%;
          transform: translate(-50%, 0);
          border: solid 1px #fafafa;
          font-family: 'HongqiFont';
          cursor: pointer;
          z-index: 99;
          text-align: center;
          color: #fafafa;
        }
        .btn:hover {
          background-color: rgba(255, 255, 255, 1);
          color: #222;
        }
      }
      .about-item:hover {
        // background-color: #222;
        .car-img {
          transform: scale3d(1.1, 1.1, 1.1);
          // opacity: 0.1;
        }
      }

      // .about-item:nth-child(1),
      // .about-item:nth-child(2) {
      //   width: calc((100% - 30px) / 2);
      //   margin-bottom: 30px;
      // }

      // .about-item:nth-child(3),
      // .about-item:nth-child(4),
      // .about-item:nth-child(5) {
      //   width: calc((100% - 60px) / 3);
      //   border: solid 1px #333;
      // }
    }
  }
  // ------------------------ 红旗活动**start ------------------------
  .events-hq {
    padding: 80px 0;
    .events-box {
      max-width: 1770px;
      margin: 0 auto;
    }
    .box {
      padding: 80px 20px 0;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .about-item {
        overflow: hidden;
        width: calc((100% - 60px) / 3);
        margin-bottom: 40px;
        .car-img {
          width: 100%;
          transition: all 0.6s;
          aspect-ratio: 16 / 10;
          overflow: hidden;
          cursor: pointer;
        }
        .car-img:hover {
          transform: scale3d(1.05, 1.05, 1.05);
        }

        .text {
          height: 48px;
          margin: 10px 0;
          // padding-bottom: 5%;
          font-weight: 700;
          // border-bottom: solid 1px #222;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          cursor: pointer;
          color: #333;
        }
        .b-box {
          // padding-top: 30px;
          padding-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .date {
            font-size: 14px;
          }
          .btn {
            width: 100px;
            line-height: 32px;
            font-size: 12px;
            text-align: center;
            border: solid 2px #333;
            cursor: pointer;
            z-index: 9999;
            color: #333;
          }
          .btn:hover {
            background-color: rgba(255, 255, 255, 1);
            color: #222;
          }
        }
      }
      .about-item:nth-child(n + 2) {
        margin-left: 30px;
      }
      .about-item:nth-child(3n + 1) {
        margin-left: 0;
      }
      // .about-item:hover {
      //   .car-img {
      //     transform: scale3d(1.1, 1.1, 1.1);
      //   }
      // }
    }
  }
}
// .el-divider__text {
//   cursor: pointer;
// }
.more-news {
  width: 240px;
  margin: 30px auto 0;
  line-height: 54px;
  text-align: center;
  border-radius: 5px;
  border: #222 solid 1px;
  cursor: pointer;
}
.more-news:hover {
  border: #222 solid 1px;
  background-color: #222;
  color: #fff;
}
@import './css/HomeView-media';
</style>
